'use strict';

export default (function () {
  // Find meta-tag with email
  var emailInput = document.querySelector('input[name="form_email_replace"]');
  var formField = document.querySelector('.wpcf7-form input[name="email"]');

  if (emailInput !== null && formField !== null) {
    formField.value = emailInput.value;
  }

  var inputForFocus = document.getElementById('first-name');

  if (inputForFocus) {
    inputForFocus.focus();
  }

  var freeQuoteTextarea = document.querySelector('textarea[name="brief-description"]');

  if (freeQuoteTextarea) {
    freeQuoteTextarea.setAttribute('rows', '');
    freeQuoteTextarea.setAttribute('cols', '');
    var textareaChangeObserve;

    if (window.attachEvent) {
      textareaChangeObserve = function textareaChangeObserve(element, event, handler) {
        element.attachEvent('on' + event, handler);
      };
    } else {
      textareaChangeObserve = function textareaChangeObserve(element, event, handler) {
        element.addEventListener(event, handler, false);
      };
    }

    var textareaAutoexpandInit = function textareaAutoexpandInit() {
      function autoexpand() {
        freeQuoteTextarea.style.height = '46px';
        freeQuoteTextarea.style.height = freeQuoteTextarea.scrollHeight + 'px';
      }

      function delayedExpand() {
        window.setTimeout(autoexpand, 0);
      }

      textareaChangeObserve(freeQuoteTextarea, 'change', autoexpand);
      textareaChangeObserve(freeQuoteTextarea, 'cut', delayedExpand);
      textareaChangeObserve(freeQuoteTextarea, 'paste', delayedExpand);
      textareaChangeObserve(freeQuoteTextarea, 'drop', delayedExpand);
      textareaChangeObserve(freeQuoteTextarea, 'keydown', delayedExpand);
      autoexpand();
    };

    textareaAutoexpandInit();
  }

  var formFields = Array.from(document.querySelectorAll('.crispwp-contact-form__field'));
  document.addEventListener('wpcf7invalid', function () {
    var fields = Array.from(document.querySelectorAll('.crispwp-contact-form__field'));
    var fieldsInvalid = Array.from(document.querySelectorAll('.crispwp-contact-form__field.wpcf7-not-valid'));

    for (var _i = 0, _fields = fields; _i < _fields.length; _i++) {
      var field = _fields[_i];
      var errorElement = field.parentElement.nextElementSibling;
      var label = field.parentElement.previousElementSibling;

      if (field.classList.contains('wpcf7-not-valid')) {
        errorElement.classList.add('is-show');
        label.classList.add('invalid');
        fieldsInvalid[0].focus();
      } else {
        errorElement.classList.remove('is-show');
        label.classList.remove('invalid');
      }
    }
  }, false);
  document.addEventListener('wpcf7mailsent', function () {
    freeQuoteTextarea.style.height = '46px';
    var fields = Array.from(document.querySelectorAll('.crispwp-contact-form__label.invalid'));
    var successMessage = document.querySelector('.crispwp-contact-form__success');

    for (var _i2 = 0, _fields2 = fields; _i2 < _fields2.length; _i2++) {
      var field = _fields2[_i2];
      field.parentElement.querySelector('.crispwp-contact-form__error-message.is-show').classList.remove('is-show');
      field.classList.remove('invalid');
    }

    successMessage.classList.add('is-show');
    setTimeout(function () {
      successMessage.querySelector('span').classList.add('is-show');
    }, 250);
  }, false);

  if (formFields) {
    formFields.forEach(function (element) {
      element.addEventListener('focus', function () {
        this.parentElement.nextElementSibling.classList.add('is-focus');
      });
      element.addEventListener('blur', function () {
        this.parentElement.nextElementSibling.classList.remove('is-focus');
      });
    });
  }

  $(document).on('click', '.dnd-icon-remove', function (e) {
    $('#attachment-file').val('');
  });
});